module.exports = __webpack_public_path__ + "img/4-quad.8f95f795.png";